<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <!-- HEADER -->
      <SubpageHeader
        :is_sticky="true"
        :background_color="bg"
        :foreground_color="fg"
        @backBtnClicked="test()"
      >
        <template #rightside>
          <!-- SEARCH -->
          <SearchBar
            :background_color="bg"
            :foreground_color="fg"
            :is_live_emit="true"
            @search="search_term=$event || ''"
          />
        </template>
        <template #below>
          <div class="work-package-image-filter-container">
            <!-- DISPLAY BUTTONS -->
            <div class="work-package-image-display-buttons">

              <!-- TOGGLE LIST DISPLAY -->
              <RadioButtonSquare
                :id="'work-package-image-display-list'"
                :width="40"
                :is_active="radio_btns.active_btn == 'work-package-image-display-list'"
                :background_color="bg"
                :foreground_color="fg"
                @setActive="setRadioBtnActive($event)"
              >
                <template #content>
                  <v-icon
                    :color="radio_btns.active_btn == 'work-package-image-display-list'
                      ? bg
                      : fg"
                  >
                    mdi-format-list-bulleted
                  </v-icon>
                </template>
              </RadioButtonSquare>

              <!-- TOGGLE TILE DISPLAY -->
              <RadioButtonSquare
                :id="'work-package-image-display-tiles'"
                :width="40"
                :is_active="radio_btns.active_btn == 'work-package-image-display-tiles'"
                :background_color="bg"
                :foreground_color="fg"
                @setActive="setRadioBtnActive($event)"
              >
                <template #content>
                  <v-icon
                    :color="radio_btns.active_btn == 'work-package-image-display-tiles'
                      ? bg
                      : fg"
                  >
                    mdi-dots-grid
                  </v-icon>
                </template>
              </RadioButtonSquare>
            </div>

            <!-- SELECT FILTER -->
            <DropDown
              :items="search_filter_items"
              :default_item="'Latest'"
              :placeholder="'Filter'"
              :max_width="120"
              :background_color="bg"
              :foreground_color="fg"
              :light="is_light_mode(fg)"
              @selected="search_filter_selected=$event"
            />
          </div>
        </template>
      </SubpageHeader>

      <div class="work-package-image-container">
        <!-- IMAGE TILES -->
        <!-- <TransitionFade> -->
          <WorkPackageImageGallery
            v-if="is_display_tiles"
            :categorized_images="categorized_images"
            :background_color="bg"
            :foreground_color="fg"
            @emittedClick="handleClickEvent($event)"
          />
        <!-- </TransitionFade> -->

        <!-- IMAGE LIST -->
        <!-- <TransitionFade> -->
          <WorkPackageImageList
            v-if="!is_display_tiles"
            :categorized_images="categorized_images"
            :background_color="bg"
            :foreground_color="fg"
            @emittedClick="handleClickEvent($event)"
          />
        <!-- </TransitionFade> -->
      </div>
    </div>
  </div>
</template>

<script>
import RadioButtonSquare from '@/components/WorkPackageWIP/RadioButtonSquare.component.vue';
import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';
import WorkPackageImageList from '@/modules/WorkPackageWIP/WorkPackageImageList.module.vue';
import WorkPackageImageGallery from '@/modules/WorkPackageWIP/WorkPackageImageGallery.module.vue';
import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';
// import TransitionFade from '@/components/WorkPackageWIP/TransitionFade.component.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';

  export default {
    components: {
      RadioButtonSquare,
      SearchBar,
      DropDown,
      WorkPackageImageList,
      WorkPackageImageGallery,
      SubpageHeader,
      // TransitionFade,
    },

    mixins: [
      WorkPackageWIPMixin,
    ],

    computed: {
      sorted_images() {
        let ret = this.images;
        let sort_key;
        let is_reversed;

        if(this.search_filter_selected == 'Latest') {
          ret = ret.filter(image =>
            image.description.toLowerCase().includes(this.search_term.toLowerCase()) ||
            image.step.toLowerCase().includes(this.search_term.toLowerCase()) ||
            image.date.toLowerCase().includes(this.search_term.toLowerCase()) ||
            image.pers.first_name.toLowerCase().includes(this.search_term.toLowerCase()) ||
            image.pers.last_name.toLowerCase().includes(this.search_term.toLowerCase())
          );
          sort_key = 'date';
          is_reversed = true;
        }
        else if(this.search_filter_selected == 'Description') {
          ret = ret.filter(image => image.description.toLowerCase().includes(this.search_term.toLowerCase()));
          sort_key = 'description';
        }
        else if(this.search_filter_selected == 'Step') {
          ret = ret.filter(image => image.step.toLowerCase().includes(this.search_term.toLowerCase()));
          for(let i = 0; i < ret.length; i++) {
            switch (ret[i].step) {
              case 'LOGISTIC.step':
                ret[i].step_number = '01';
                break;
              case 'DESIGN.step':
                ret[i].step_number = '02';
                break;
              case 'WORK.step':
                ret[i].step_number = '03';
                break;
              case 'QUALITY.step':
                ret[i].step_number = '04';
                break;
              case 'DEFECT.step':
                ret[i].step_number = '05';
                break;
              case 'HANDOVER.step':
                ret[i].step_number = '06';
                break;
              case 'MATERIAL.step':
                ret[i].step_number = '07';
                break;
              case 'TOOL.step':
                ret[i].step_number = '08';
                break;
              case 'SENSOR.step':
                ret[i].step_number = '09';
                break;
              case 'ROBOTICS.step':
                ret[i].step_number = '10';
                break;
              default:
                ret[i].step_number = '00';
            }
          }
          sort_key = 'step_number';
        }
        else if(this.search_filter_selected == 'Date') {
          ret = ret.filter(image => image.date.toLowerCase().includes(this.search_term.toLowerCase()));
          sort_key = 'date';
          is_reversed = true;
        }
        else if(this.search_filter_selected == 'Person') {
          ret = ret.filter(image => image.person_string.toLowerCase().includes(this.search_term.toLowerCase()));
          sort_key = 'person_string';
        }

        this.sortObjectArrayByValueOfKey(ret, sort_key);

        // important for dates
        if(is_reversed) {
          ret.reverse();
        }

        return ret;
      },

      categorized_images() {
        let img_links_arr = [];
        let arr_idx = -1;

        if(!this.sorted_images.length) {
          return [];
        }

        switch (this.search_filter_selected) {
          case 'Description':
            for(let i = 0; i < this.sorted_images.length; i++) {
              if(
                img_links_arr[arr_idx] &&
                this.sorted_images[i].description[0].toUpperCase() === img_links_arr[arr_idx].category
              ) {
                img_links_arr[arr_idx].data.push(this.sorted_images[i]);
              }
              else {
                arr_idx++;
                img_links_arr.push({
                  category: this.sorted_images[i].description[0].toUpperCase(),
                  data: [this.sorted_images[i]]
                });
              }
            }
            return img_links_arr;

          case 'Step':
            for(let i = 0; i < this.sorted_images.length; i++) {
              if(
                img_links_arr[arr_idx] &&
                this.sorted_images[i].step === img_links_arr[arr_idx].category
              ) {
                img_links_arr[arr_idx].data.push(this.sorted_images[i]);
              }
              else {
                arr_idx++;
                img_links_arr.push({
                  category: this.sorted_images[i].step,
                  data: [this.sorted_images[i]]
                });
              }
            }
            return img_links_arr;

          case 'Date':
            for(let i = 0; i < this.sorted_images.length; i++) {
              if(
                img_links_arr[arr_idx] &&
                this.sorted_images[i].date_string === img_links_arr[arr_idx].category
              ) {
                img_links_arr[arr_idx].data.push(this.sorted_images[i]);
              }
              else {
                arr_idx++;
                img_links_arr.push({
                  category: this.sorted_images[i].date_string,
                  data: [this.sorted_images[i]]
                });
              }
            }
            return img_links_arr;
          case 'Person':
            for(let i = 0; i < this.sorted_images.length; i++) {
              if(
                img_links_arr[arr_idx] &&
                this.sorted_images[i].person_string === img_links_arr[arr_idx].category
              ) {
                img_links_arr[arr_idx].data.push(this.sorted_images[i]);
              }
              else {
                arr_idx++;
                img_links_arr.push({
                  category: this.sorted_images[i].person_string,
                  data: [this.sorted_images[i]]
                });
              }
            }
            return img_links_arr;
          default:
            return [{ category: '', data: this.sorted_images }];
        }
      },
    },

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      is_edit: false,

      search_term: '',

      is_display_tiles: true,

      search_filter_selected: 'Latest',
      search_filter_items: [
        'Latest', 'Description', 'Step', 'Date', 'Person',
      ],

      img: 'https://images.pexels.com/photos/10154570/pexels-photo-10154570.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',

      images: [
        {
          id: 0,
          image: 'https://images.pexels.com/photos/10154570/pexels-photo-10154570.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Jimage1',
          step: 'HANDOVER.step',
          date: '2021-09-13 10:07:27 UTC',
          pers: { first_name: 'Marco', last_name: 'Herold' },
        },
        {
          id: 1,
          image: 'https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Image33',
          step: '-',
          date: '2021-10-22 10:07:27 UTC',
          pers: { first_name: 'Timo', last_name: 'Vogelsang' },
        },
        {
          id: 2,
          image: 'https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Image3',
          step: 'WORK.step',
          date: '2021-11-22 10:05:27 UTC',
          pers: { first_name: 'Klaus', last_name: 'Schreier' },
        },
        {
          id: 3,
          image: 'https://images.pexels.com/photos/440731/pexels-photo-440731.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Image4',
          step: 'LOGISTIC.step',
          date: '2021-12-13 10:07:27 UTC',
          pers: { first_name: 'Florian', last_name: 'Genz' },
        },
        {
          id: 4,
          image: 'https://images.pexels.com/photos/417173/pexels-photo-417173.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
          description: 'image4',
          step: '-',
          date: '2021-12-13 09:07:27 UTC',
          pers: { first_name: 'Jürgen', last_name: 'Pape' },
        },
        {
          id: 5,
          image: 'https://images.pexels.com/photos/1036657/pexels-photo-1036657.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
          description: 'image5',
          step: '-',
          date: '2022-01-13 09:07:27 UTC',
          pers: { first_name: 'Jürgen', last_name: 'Pape' },
        },
        {
          id: 6,
          image: 'https://images.pexels.com/photos/6889376/pexels-photo-6889376.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Lampe',
          step: '-',
          date: '2020-12-12 10:07:27 UTC',
          pers: { first_name: 'Jürgen', last_name: 'Pape' },
        },
        {
          id: 7,
          image: 'https://images.pexels.com/photos/10214542/pexels-photo-10214542.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260',
          description: 'Brücke',
          step: '-',
          date: '2021-12-13 10:07:28 UTC',
          pers: { first_name: 'Jürgen', last_name: 'Pape' },
        },
        {
          id: 8,
          image: 'https://images.pexels.com/photos/10117700/pexels-photo-10117700.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Komode',
          step: '-',
          date: '2021-12-13 11:07:27 UTC',
          pers: { first_name: 'Florian', last_name: 'Genz' },
        },
        {
          id: 9,
          image: 'https://images.pexels.com/photos/8090531/pexels-photo-8090531.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Kaskade',
          step: 'WORK.step',
          date: '2021-11-22 10:01:27 UTC',
          pers: { first_name: 'Klaus', last_name: 'Schreier' },
        },
        {
          id: 10,
          image: 'https://images.pexels.com/photos/9544524/pexels-photo-9544524.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Felsen',
          step: 'ROBOTICS.step',
          date: '2021-10-21 10:07:27 UTC',
          pers: { first_name: 'Timo', last_name: 'Vogelsang' },
        },
        {
          id: 11,
          image: 'https://images.pexels.com/photos/9715702/pexels-photo-9715702.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Blätter',
          step: 'HANDOVER.step',
          date: '2021-11-22 10:08:27 UTC',
          pers: { first_name: 'Marco', last_name: 'Herold' },
        },
        {
          id: 12,
          image: 'https://images.pexels.com/photos/2128159/pexels-photo-2128159.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
          description: 'Riesenrad',
          step: 'TOOL.step',
          date: '2021-12-23 10:07:27 UTC',
          pers: { first_name: 'Marco', last_name: 'Herold' },
        },
        {
          id: 13,
          image: 'https://images.pexels.com/photos/190219/pexels-photo-190219.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          description: 'Abend',
          step: 'SENSOR.step',
          date: '2021-10-21 08:07:27 UTC',
          pers: { first_name: 'Timo', last_name: 'Vogelsang' },
        },
      ]
    }),

    methods: {

      handleRadioButtonSelected(string) {
        this.is_display_tiles = string == 'work-package-image-display-tiles';
      },
    },

    mounted() {
      this.initRadioBtns(
        false,
        false,
        (this.is_display_tiles)
          ? 'work-package-image-display-tiles'
          : 'work-package-image-display-list'
      );

      let date;
      let date_string;
      for(let i = 0; i < this.images.length; i++) {
        this.images[i].person_string = `${this.images[i].pers.last_name}, ${this.images[i].pers.first_name}`;

        date = new Date(this.images[i].date.split(' UTC')[0]);
        date_string = '';
        date_string += this.getWeekdayString(date.getDay());
        date_string += ', ';
        date_string += date.getDate();
        date_string += '. ';
        date_string += this.getMonthString(date.getMonth());
        date_string += ' ';
        date_string += date.getFullYear();

        this.images[i].date_string = date_string;
      }
    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 0 10px;
  }
  .work-package-image-filter-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
  }
  .work-package-image-container {
    position: relative;
  }
  .work-package-image-display-buttons {
    display: flex;
    flex-direction: row;
    grid-gap: 8px;
  }
</style>
